/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

/**
 * @extends {Object}
 * @constructor
 */
import Shape from "App/geometry/objects/shape";
import Factory from "App/geometry/objects/factory";
import ModelDescription from "App/model/description";
import {RenderElement} from "App/model/elements/element";
import GeometryFactory from "App/geometry/objects_geometry/factory";
import ShapeBatchNode from "App/render/webgl/nodes/shape_batch_node";
import VolumetricShapeBatch from "App/render/webgl/renderables/batches/volumetric_shape_batch";

export default
class ChunkLODNodeShape extends Shape {

    public static TypeName: string = "CHUNKLODNODESHAPE";

    constructor(aUID: number) {
        super(aUID);
    }

    public static create(aUID: number): ChunkLODNodeShape {
        return new ChunkLODNodeShape(aUID);
    }

    public getVisibility(): boolean {
        this._renderGraphObject.invalidateVisibilityCache(); // evaluate the visibility all the time as we have only one shape per batch

        return this._elementRef.getVisibility();
    }

    public parse(aModelDescription: ModelDescription, aShapeJSON: any, aElement: RenderElement) {
        let geomTypePair = GeometryFactory.create(aShapeJSON, this);
        this.geometry = geomTypePair.geometry;

        this.geometry.parse(aShapeJSON[geomTypePair.type]);

        // then continue to appearance
        super.parse(aModelDescription, aShapeJSON, aElement);
    }
}

Factory.register(ChunkLODNodeShape);
ShapeBatchNode.registerGeometryObject(ChunkLODNodeShape.TypeName, VolumetricShapeBatch);